import { useMemo, useState } from "react";

import { Roles } from "@doitintl/cmp-models";

import { type MetricWSnap } from "../../../types";
import ShareDialog from "../dialogs/shareDialog/ShareDialog";
import { CloudAnalyticsEntities } from "../utilities";
import { useShareMetricHandler } from "./hooks";

export type Props = {
  open: boolean;
  metrics: MetricWSnap[];
  onClose: () => void;
};

export function MetricsShareDialog({ open, metrics, onClose }: Props) {
  const [shareLoading, setShareLoading] = useState(false);
  const handleSharingChanged = useShareMetricHandler(metrics, onClose, setShareLoading);

  const shareEntities = useMemo(
    () =>
      metrics.map((metric) => ({
        name: metric.data.name,
        collaborators: metric.data.collaborators,
        public: metric.data.public,
      })),
    [metrics]
  );

  return (
    <ShareDialog
      open={open}
      onClose={onClose}
      entity={CloudAnalyticsEntities.METRIC}
      loading={shareLoading}
      availableRoles={[Roles.EDITOR, Roles.VIEWER]}
      defaultRole={Roles.EDITOR}
      shareEntities={shareEntities}
      onSharingChanged={handleSharingChanged}
    />
  );
}
